import { useAuth } from "@/contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  ClipboardList,
  Users,
  Building2,
  MapPin,
  Settings,
  LogOut,
  Calendar,
  FileBarChart,
  Wrench,
  Mail,
  Brain,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

const adminLinks = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard },
  { to: "/work-orders", label: "İş Emirleri", icon: ClipboardList },
  { to: "/customers", label: "Müşteriler", icon: Building2 },
  { to: "/locations", label: "Lokasyonlar", icon: MapPin },
  { to: "/technicians", label: "Teknisyenler", icon: Users },
  { to: "/calendar", label: "Takvim", icon: Calendar },
  { to: "/reports", label: "Raporlar", icon: FileBarChart },
  { to: "/analytics", label: "İş Zekası", icon: Brain },
  { to: "/email-logs", label: "E-posta Logları", icon: Mail },
  { to: "/settings", label: "Tanımlamalar", icon: Settings },
];

const technicianLinks = [
  { to: "/", label: "İş Listesi", icon: ClipboardList },
  { to: "/calendar", label: "Takvim", icon: Calendar },
];

export default function AppSidebar({ onNavigate }: { onNavigate?: () => void }) {
  const { role, signOut, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const links = role === "admin" ? adminLinks : technicianLinks;

  return (
    <aside className="flex h-screen w-64 flex-col bg-sidebar text-sidebar-foreground border-r border-sidebar-border">
      {/* Logo */}
      <div className="flex items-center gap-3 px-6 py-5">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-sidebar-primary">
          <Wrench className="h-5 w-5 text-sidebar-primary-foreground" />
        </div>
        <div>
          <h1 className="text-sm font-bold text-sidebar-primary-foreground">Saha Servis</h1>
          <p className="text-xs text-sidebar-foreground/60">Yönetim Sistemi</p>
        </div>
      </div>

      <Separator className="bg-sidebar-border" />

      {/* Nav */}
      <nav className="flex-1 space-y-1 px-3 py-4">
        {links.map((link) => {
          const isActive = location.pathname === link.to;
          return (
            <button
              key={link.to}
              onClick={() => { navigate(link.to); onNavigate?.(); }}
              className={cn(
                "flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                isActive
                  ? "bg-sidebar-accent text-sidebar-primary"
                  : "text-sidebar-foreground/70 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
              )}
            >
              <link.icon className="h-4 w-4" />
              {link.label}
            </button>
          );
        })}
      </nav>

      <Separator className="bg-sidebar-border" />

      {/* User */}
      <div className="p-4">
        <p className="mb-2 truncate text-xs text-sidebar-foreground/60">{user?.email}</p>
        <Button
          variant="ghost"
          size="sm"
          className="w-full justify-start text-sidebar-foreground/70 hover:text-destructive"
          onClick={signOut}
        >
          <LogOut className="mr-2 h-4 w-4" />
          Çıkış Yap
        </Button>
      </div>
    </aside>
  );
}
